import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

function CompanyAndSupplierDetailsTemplate() {
  const { t } = useTranslation('purchase-order');
  const autoFilledText = t('PO_TEMPLATE.DETAIL_PAGE.AUTO_FILLED', 'Auto Filled');
  const defaultCompanyDetailsP1 = {
    [t('PO_TEMPLATE.DETAIL_PAGE.COMPANY_NAME')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.COMPANY_NUMBER')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.VAT_REGISTRATION_NO')]: autoFilledText,
    [t('COMMON_LABEL.BRAND')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.PAYMENT_TERMS')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.BILLING_ADDRESS')]: autoFilledText,
  };

  const defaultCompanyDetailsP2 = {
    [t('PO_TEMPLATE.DETAIL_PAGE.CONTACT_PERSON')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.CONTACT_PERSON_EMAIL')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.CREATED_BY')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.CREATED_BY_EMAIL')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.DEFAULT_SHIPPING_ADDRESS')]: autoFilledText,
  };

  const defaultSupplierFactoryDetailsP1 = {
    [t('PO_TEMPLATE.DETAIL_PAGE.SUPPLIER_NAME')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.SUPPLIER_CODE')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.SUPPLIER_CONTACT_NAME')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.SUPPLIER_CONTACT_EMAIL')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.SUPPLIER_ADDRESS')]: autoFilledText,
  };

  const defaultSupplierFactoryDetailsP2 = {
    [t('PO_TEMPLATE.DETAIL_PAGE.FACTORY_NAME')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.FACTORY_CODE')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.FACTORY_CONTACT_NAME')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.FACTORY_CONTACT_EMAIL')]: autoFilledText,
    [t('PO_TEMPLATE.DETAIL_PAGE.FACTORY_ADDRESS')]: autoFilledText,
  };

  return (
    <div className="inner-container po-template-name">
      <div className="row p-10">
        <div className=" col-md-6">
          <div className="section-template-title">{t('PO_TEMPLATE.DETAIL_PAGE.COMPANY_DETAILS')}</div>
          <div className="row">
            <div className="col-md-6 ">
              {Object.entries(defaultCompanyDetailsP1).map(([key, value]) => (
                <div key={key} className="flex justify-between items-center">
                  <span className="text-sm font-medium text-foreground">{key}: </span>
                  <span className="text-sm text-muted-foreground">{value}</span>
                </div>
              ))}
            </div>
            <div className="col-md-6 ">
              {Object.entries(defaultCompanyDetailsP2).map(([key, value]) => (
                <div key={key} className="flex justify-between items-center">
                  <span className="text-sm font-medium text-foreground">{key}: </span>
                  <span className="text-sm text-muted-foreground">
                    {key === t('PO_TEMPLATE.DETAIL_PAGE.CONTACT_PERSON') ? (
                      <div className="w-100 m-w-150 common-react-select mb-0">
                        <Select
                          name="contactPerson"
                          options={[]}
                          className="common-select"
                          classNamePrefix="common-select"
                          placeholder={t('CREATE_EDIT_PO.SELECT_CONTACT_PERSON', 'Select Contact Person')}
                          value={null}
                          menuPosition="fixed"
                          maxMenuHeight={150}
                          isClearable
                          isDisabled
                        />
                      </div>
                    ) : (
                      value
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="section-template-title">{t('PO_TEMPLATE.DETAIL_PAGE.SUPPLIER_FACTORY_DETAILS')}</div>
          <div>
            <div className="row">
              <div className="col-md-6 ">
                {Object.entries(defaultSupplierFactoryDetailsP1).map(([key, value]) => (
                  <div key={key} className="flex justify-between items-center">
                    <span className="text-sm font-medium text-foreground">{key}: </span>
                    <span className="text-sm text-muted-foreground">{value}</span>
                  </div>
                ))}
              </div>
              <div className="col-md-6 ">
                {Object.entries(defaultSupplierFactoryDetailsP2).map(([key, value]) => (
                  <div key={key} className="flex justify-between items-center">
                    <span className="text-sm font-medium text-foreground">{key}: </span>
                    <span className="text-sm text-muted-foreground">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyAndSupplierDetailsTemplate;
